import React from "react";
import classNames from "classnames";
import { BemHelper } from "../../utils/BemHelper";

type Props = {
  collapsed?: boolean;
  label: string;
  icon: React.ReactNode;
  active?: boolean;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  href?: string;
  target?: "_blank" | "_self" | "_parent" | "_top";
  disabled?: boolean;
};

const bem = new BemHelper("sidebar-option");

export const SidebarOption: React.FC<Props> = ({
  collapsed,
  label,
  icon,
  active,
  onClick,
  href,
  target = "_self",
  disabled,
}) => (
  <a
    className={classNames([bem.block(), disabled && bem.modifier("disabled")])}
    onClick={onClick}
    href={href}
    target={target}
  >
    <div
      className={classNames(
        bem.element("content"),
        collapsed && bem.modifier("collapsed", "content"),
        active && bem.modifier("active", "content"),
      )}
    >
      <div className={classNames(bem.element("icon"))}>{icon}</div>
      <label className={classNames(bem.element("label"))}>{label}</label>
    </div>
  </a>
);
